/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Fmt_NoteInputs */

const en_vc_fmt_note = /** @type {(inputs: Vc_Fmt_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Illustrator .ai files open when they were saved with PDF compatibility (the default), and legacy version 7 .ai files keep their layers, groups and type. Proprietary Illustrator-only editing data is not written back, and reliable round trips with real-world .ai files are still being worked on.`)
};

const zh_vc_fmt_note = /** @type {(inputs: Vc_Fmt_NoteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`以 PDF 兼容方式保存的 Illustrator .ai 文件（Illustrator 默认如此）可以打开；旧版第 7 版 .ai 文件能保留图层、编组和文字。Illustrator 专有的编辑数据不会写回，与复杂的真实 .ai 文件稳定互通仍在开发中。`)
};

/**
* | output |
* | --- |
* | "Illustrator .ai files open when they were saved with PDF compatibility (the default), and legacy version 7 .ai files keep their layers, groups and type. Prop..." |
*
* @param {Vc_Fmt_NoteInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_fmt_note = /** @type {((inputs?: Vc_Fmt_NoteInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Fmt_NoteInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_fmt_note(inputs)
	return zh_vc_fmt_note(inputs)
});
export { vc_fmt_note as "vc.fmt.note" }